import React, { memo } from 'react';
import {
  FormPageInputItemTextZipCode,
  TextZipCodeInput,
  TextPropertyZipCode,
  mappedConst,
} from 'shared';
import { FormFieldZipCodeInputItemProps } from './shared';

type Props = FormFieldZipCodeInputItemProps<
  TextPropertyZipCode,
  FormPageInputItemTextZipCode
> & {
  first: FormPageInputItemTextZipCode['first'];
  second: FormPageInputItemTextZipCode['second'];
};

type UpdateKey = keyof Pick<FormPageInputItemTextZipCode, 'first' | 'second'>;
const UPDATE_KEY: mappedConst<UpdateKey> = {
  first: 'first',
  second: 'second',
};

export const TextZipCode: React.FC<Props> = memo(
  ({
    property,
    disabled,
    design,
    first: firstValue,
    second: secondValue,
    onChange,
    onBlur,
    className,
    errorMessages,
    displayError,
    onAutoCompleteAddressButtonClick,
    reEnter,
  }) => {
    const { propertyId, inputFormat } = property;
    const { first, second, searchSetting } = inputFormat;
    const createChangeHandler = (key: UpdateKey) => (inputData: string) => {
      onChange(key, inputData);
    };
    const createBlurHandler = (key: UpdateKey) => (inputData: string) => {
      onBlur(key, inputData);
    };
    const handleClick = () => {
      onAutoCompleteAddressButtonClick(
        propertyId,
        `${firstValue ?? ''}${secondValue ?? ''}`,
      );
    };
    return (
      <TextZipCodeInput
        propertyId={propertyId}
        firstPlaceholder={reEnter ? '' : first.placeholder}
        secondPlaceholder={reEnter ? '' : second.placeholder}
        first={firstValue}
        second={secondValue}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onFirstChange={createChangeHandler(UPDATE_KEY.first)}
        onSecondChange={createChangeHandler(UPDATE_KEY.second)}
        onFirstBlur={createBlurHandler(UPDATE_KEY.first)}
        onSecondBlur={createBlurHandler(UPDATE_KEY.second)}
        design={design}
        className={className}
        displayAutoCompleteAddressButton={searchSetting != null}
        autoCompleteAddressButtonLabel={searchSetting?.searchButtonLabel || ''}
        onAutoCompleteAddressButtonClick={handleClick}
      />
    );
  },
);
